import React, { useEffect, useState } from 'react';
import './KhuCongNghiep.css'

function KhuCongNghiep () {
    useEffect(() => {
   
       // đợi leaflet load
       if (!window.L) return;
   
       const L = window.L;
   
       // tránh map bị render nhiều lần
       if (window.dashboardMapInstance) {
         window.dashboardMapInstance.remove();
       }
   
       // ===== TẠO MAP =====
   
       const map = L.map("dashboardmapindus", {
         zoomControl: false,
         attributionControl: false
       }).setView([10.5216, 105.1259], 9);
   
       window.dashboardMapInstance = map;
   
       // ===== TILE MAP =====
   
       L.tileLayer(
         "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        //  {
        //    attribution: "&copy; OpenStreetMap contributors"
        //  }
       ).addTo(map);
   
       // ===== ZOOM CONTROL =====
   
       L.control.zoom({
         position: "bottomleft"
       }).addTo(map);
   
       // ===== CUSTOM ICON =====
   
       const industrialIcon = L.divIcon({
         html: `
           <div class="custom-map-marker-indus">
             <i class="fas fa-industry"></i>
           </div>
         `,
         className: "",
         iconSize: [40, 40],
         iconAnchor: [20, 20]
       });
   
       // ===== 6 KHU CÔNG NGHIỆP =====
   
       const locations = [
   
         {
           name: "KCN Bình Hòa",
           area: "318 ha",
           coords: [10.6437, 105.012]
         },
   
         {
           name: "KCN Bình Hòa 2",
           area: "250 ha",
           coords: [10.598, 105.15]
         },
   
         {
           name: "KCN Vàm Cống",
           area: "1.480 ha",
           coords: [10.400, 105.470]
         },
   
         {
           name: "KCN Thoại Sơn",
           area: "247 ha",
           coords: [10.274, 105.290]
         },
   
         {
           name: "KCN Hội An",
           area: "296 ha",
           coords: [10.480, 105.240]
         },
   
         {
           name: "KCN Vĩnh Thạnh Trung",
           area: "410 ha",
           coords: [10.780, 105.250]
         }
   
       ];
   
       locations.forEach((item) => {
   
         L.marker(item.coords, {
           icon: industrialIcon
         })
           .addTo(map)
           .bindPopup(`
             <div class="map-popup">
               <b>${item.name}</b>
               <br/>
               ${item.area}
             </div>
           `);
   
       });
   
       // ===== VẼ RANH GIỚI AN GIANG =====
   
       const anGiangBorder = [
   
         [10.940, 104.780],
         [10.920, 105.030],
         [10.840, 105.240],
         [10.780, 105.420],
         [10.620, 105.520],
         [10.420, 105.540],
         [10.230, 105.430],
         [10.090, 105.260],
         [10.120, 104.980],
         [10.240, 104.790],
         [10.450, 104.720],
         [10.700, 104.700],
         [10.940, 104.780]
   
       ];
   
       L.polygon(anGiangBorder, {
         color: "#5d56ff",
         fillColor: "#5d56ff",
         fillOpacity: 0.05,
         weight: 3
       }).addTo(map);
   
     }, []);

       const [openIndustrialModal, setOpenIndustrialModal] = useState(false);
        const [step, setStep] = useState(1);
        const [showCreateModal, setShowCreateModal] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
           /* OPEN */
    const handleOpenIndustrialModal = () => {
        setOpenIndustrialModal(true);
    };

    
    const handleCloseIndustrialModal = () => {
        setOpenIndustrialModal(false);
    };




  //     const handleOpenModal = () => {
  //   setShowCreateModal(true);
  //   setCurrentStep(1);
  // };

  // const handleCloseModal = () => {
  //   setShowCreateModal(false);
  //   setCurrentStep(1);
  // };

  // const handleNextStep = () => {
  //   setCurrentStep(currentStep + 1);
  // };

  // const handleBackStep = () => {
  //   setCurrentStep(currentStep - 1);
  // };

   const [showIndustrialZoneModal, setShowIndustrialZoneModal] =
    useState(false);

  const [industrialZoneStep, setIndustrialZoneStep] = useState(1);

  const openIndustrialZoneModal = () => {
    setShowIndustrialZoneModal(true);
    setIndustrialZoneStep(1);
  };

  const closeIndustrialZoneModal = () => {
    setShowIndustrialZoneModal(false);
  };

  const nextIndustrialZoneStep = () => {
    if (industrialZoneStep < 4) {
      setIndustrialZoneStep(industrialZoneStep + 1);
    }
  };

  const prevIndustrialZoneStep = () => {
    if (industrialZoneStep > 1) {
      setIndustrialZoneStep(industrialZoneStep - 1);
    }
  };


   
        return (
 <div className="">
  <div className="industrialDashboard">

    {/* <!-- Header --> */}
    <div className="industrialDashboardHeader">
      <div>
        <h2 className="industrialDashboardTitle">Khu công nghiệp</h2>

        <div className="industrialDashboardBreadcrumb">
          <span>Trang chủ</span>
          <i className="fa-solid fa-chevron-right"></i>
          <span>Khu công nghiệp</span>
        </div>
      </div>

      <div className="industrialDashboardHeaderRight">
            <div className='warper-all'>
                 <select className="industrialDashboardSelect">
          <option>Tất cả khu vực</option>
        </select>
        <i className="fa-solid fa-angle-down icon-indus-share"></i>
            </div>

            <div className='warper-all'>
            <select className="industrialDashboardSelectAll">
          <option>Trạng thái: Tất cả</option>
        </select>
        <i className="fa-solid fa-angle-down icon-indus-share-all"></i>
            </div>

        <button className="industrialDashboardButton" onClick={openIndustrialZoneModal} >
          <i className="fa-solid fa-plus"></i>
          Thêm khu công nghiệp
        </button>
        
      </div>
    </div>

    {/* <!-- Statistic Cards --> */}
    <div className="industrialStatisticGrid">

      <div className="industrialStatisticCard">
        <div className="industrialStatisticIcon industrialPurple">
          <i className="fa-regular fa-building"></i>
        </div>

        <div className='Share'>
          <h3 className="industrialStatisticNumber">08</h3>
          <p className="industrialStatisticLabel">Khu công nghiệp</p>
          <span className="industrialStatisticSub">Tổng số KCN</span>
        </div>
      </div>

      <div className="industrialStatisticCard">
        <div className="industrialCircleProgress industrialGreen">
          <div className="industrialCircleInner"></div>
        </div>

        <div className='Share'>
          <h3 className="industrialStatisticNumber">3.251 ha</h3>
          <p className="industrialStatisticLabel">Tổng diện tích</p>
          <span className="industrialStatisticSub">Đất công nghiệp</span>
        </div>
      </div>

      <div className="industrialStatisticCard">
        <div className="industrialCircleProgress industrialPink">
          <div className="industrialCircleInner"></div>
        </div>

        <div className='Share'>
          <h3 className="industrialStatisticNumber">62,4%</h3>
          <p className="industrialStatisticLabel">Tỷ lệ lấp đầy TB</p>
          <span className="industrialStatisticSub">Toàn tỉnh</span>
        </div>
      </div>

      <div className="industrialStatisticCard">
        <div className="industrialStatisticIcon industrialOrange">
          <i className="fa-solid fa-chart-line"></i>
        </div>

        <div className='Share'>
          <h3 className="industrialStatisticNumber">356</h3>
          <p className="industrialStatisticLabel">Doanh nghiệp</p>
          <span className="industrialStatisticSub">Đang hoạt động</span>
        </div>
      </div>

      <div className="industrialStatisticCard">
        <div className="industrialStatisticIcon industrialCyan">
          <i className="fa-regular fa-user"></i>
        </div>

        <div className='Share'>
          <h3 className="industrialStatisticNumber">134.567</h3>
          <p className="industrialStatisticLabel">Lao động</p>
          <span className="industrialStatisticSub">Tổng số lao động</span>
        </div>
      </div>

    </div>

    {/* <!-- Main Content --> */}
    <div className="industrialMainGrid">

      {/* <!-- Map --> */}
      <div className="industrialMapCard">

        <div className="industrialCardHeader">
          <h3>Bản đồ khu công nghiệp</h3>
        </div>

        <div className="industrialMapWrapper">

          <div className="industrialMapArea">

            <div id="dashboardmapindus"></div>

            {/* <!-- Marker --> */}
            <div className="industrialMarker markerOne">
              <i className="fa-solid fa-building"></i>
            </div>

            <div className="industrialMarker markerTwo">
              <i className="fa-solid fa-building"></i>
            </div>

            <div className="industrialMarker markerThree">
              <i className="fa-solid fa-building"></i>
            </div>

            <div className="industrialMarker markerFour">
              <i className="fa-solid fa-building"></i>
            </div>

            <div className="industrialMarker markerFive">
              <i className="fa-solid fa-building"></i>
            </div>

            {/* <!-- Zoom --> */}
            <div className="industrialMapZoom">
              <button>+</button>
              <button>-</button>
            </div>

          </div>

          {/* <!-- Map List --> */}
          <div className="industrialMapList">

            <div className="industrialMapListItem">
              <span className="industrialDot"></span>
              <div>
                <h4>KCN Bình Hòa</h4>
                <p>318 ha</p>
              </div>
            </div>

            <div className="industrialMapListItem">
              <span className="industrialDot"></span>
              <div>
                <h4>KCN Bình Hòa 2</h4>
                <p>250 ha</p>
              </div>
            </div>

            <div className="industrialMapListItem">
              <span className="industrialDot"></span>
              <div>
                <h4>KCN Vàm Cống</h4>
                <p>1.480 ha</p>
              </div>
            </div>

            <div className="industrialMapListItem">
              <span className="industrialDot"></span>
              <div>
                <h4>KCN Thoại Sơn</h4>
                <p>247 ha</p>
              </div>
            </div>

            <div className="industrialMapListItem">
              <span className="industrialDot"></span>
              <div>
                <h4>KCN Hội An</h4>
                <p>296 ha</p>
              </div>
            </div>

            <div className="industrialMapListItem">
              <span className="industrialDot"></span>
              <div>
                <h4>KCN Bình Long</h4>
                <p>250 ha</p>
              </div>
            </div>

            <div className="industrialMapListItem">
              <span className="industrialDot"></span>
              <div>
                <h4>KCN Vĩnh Thạnh Trung</h4>
                <p>410 ha</p>
              </div>
            </div>

            <div className="industrialMapListItem">
              <span className="industrialDot"></span>
              <div>
                <h4>KCN Tân Châu</h4>
                <p>-- ha</p>
              </div>
            </div>

          </div>

        </div>
      </div>

      {/* <!-- Overview --> */}
      <div className="industrialOverviewCard">

        <div className="industrialCardHeader">
          <h3>Tổng quan toàn tỉnh</h3>

          <select className="industrialYearSelect">
            <option>Năm 2026</option>
          </select>
        </div>

        <div className="industrialOverviewContent">

          {/* <!-- Donut --> */}
          <div className="industrialDonutSection">

            <h4 className="industrialSectionTitle">
              Theo tình trạng hoạt động
            </h4>

            <div className="industrialDonutChart">

              <div className="industrialDonutOuter">
                <div className="industrialDonutCenter">
                  <h3>08</h3>
                  <span>Tổng số</span>
                </div>
              </div>

            </div>

            <div className="industrialLegend">

              <div className="industrialLegendItem">
                <span className="industrialLegendColor active"></span>
                <div>
                  <p className='p-share'>Đang hoạt động</p>
                  <span className='span-share'>08 (100%)</span>
                </div>
              </div>

              <div className="industrialLegendItem">
                <span className="industrialLegendColor preparing"></span>
                <div>
                  <p className='p-share'>Chuẩn triển khai</p>
                  <span className='span-share'>00 (0%)</span>
                </div>
              </div>

              <div className="industrialLegendItem">
                <span className="industrialLegendColor expanding"></span>
                <div>
                  <p className='p-share'>Đang giải phóng mặt bằng</p>
                  <span className='span-share'>00 (0%)</span>
                </div>
              </div>

              <div className="industrialLegendItem">
                <span className="industrialLegendColor stopped"></span>
                <div>
                  <p className='p-share'>Tạm dừng</p>
                  <span className='span-share'>00 (0%)</span>
                </div>
              </div>

            </div>

          </div>

          {/* <!-- Region --> */}
          <div className="industrialRegionSection">

            <h4 className="industrialSectionTitle">
              Theo khu vực
            </h4>

            <div className="industrialRegionItem">
              <span>TP. Long Xuyên</span>

              <div className="industrialBarWrapper">
                <div className="industrialBar purpleBar"></div>
              </div>

              <strong>03</strong>
            </div>

            <div className="industrialRegionItem">
              <span>Thị xã Tân Châu</span>

              <div className="industrialBarWrapper">
                <div className="industrialBar blueBar smallBar"></div>
              </div>

              <strong>01</strong>
            </div>

            <div className="industrialRegionItem">
              <span>Huyện Châu Phú</span>

              <div className="industrialBarWrapper">
                <div className="industrialBar blueBar smallBar"></div>
              </div>

              <strong>01</strong>
            </div>

            <div className="industrialRegionItem">
              <span>Huyện Thoại Sơn</span>

              <div className="industrialBarWrapper">
                <div className="industrialBar greenBar smallBar"></div>
              </div>

              <strong>01</strong>
            </div>

            <div className="industrialRegionItem">
              <span>Huyện Châu Thành</span>

              <div className="industrialBarWrapper">
                <div className="industrialBar greenBar smallBar"></div>
              </div>

              <strong>01</strong>
            </div>

            <div className="industrialRegionItem">
              <span>Huyện Chợ Mới</span>

              <div className="industrialBarWrapper">
                <div className="industrialBar greenBar smallBar"></div>
              </div>

              <strong>01</strong>
            </div>

          </div>

        </div>

        {/* <!-- Footer Stats --> */}
        <div className="industrialOverviewFooter">
   

          {/* <div className="industrialFooterCard">
            <span>Tổng diện tích (ha)</span>
            
            
             
               <div>
                <i className="fa-regular fa-building dashboard-stat-icon"></i>
              <h3>3.251</h3>
               </div>
            
          </div> */}
          <div className="industrialFooterCard">
  <span className="industrialFooterTitle">
    Tổng diện tích (ha)
  </span>

  <div className="industrialFooterInfo">
    <i className="fa-regular fa-building dashboardStatIcon"></i>

    <h3 className="industrialFooterValue">
      3.251
    </h3>
  </div>
</div>
  

          {/* <div className="industrialFooterCard">
             

            <div>
                <i className="fa-solid fa-industry dashboard-stat-icon"></i>
              <span>Đất công nghiệp (ha)</span>
              
              <h3>2.028</h3>
            </div>
          </div> */}
           <div className="industrialFooterCard">
  <span className="industrialFooterTitle">
    Đất công nghiệp (ha)
  </span>

  <div className="industrialFooterInfo">
    <i className="fa-solid fa-industry dashboard-stat-icon"></i>

    <h3 className="industrialFooterValue">
     2.028
    </h3>
  </div>
</div>
       

          {/* <div className="industrialFooterCard">
           <i className="fa-regular fa-square-full dashboard-stat-icon"></i>

            <div>
              <span>Đất còn trống (ha)</span>
              
              <h3>769</h3>
            </div>
          </div> */}
                     <div className="industrialFooterCard">
  <span className="industrialFooterTitle  land-zero">
   Đất còn trống (ha)
  </span>

  <div className="industrialFooterInfo">
   <i className="fa-regular fa-square-full dashboard-stat-icon"></i>

    <h3 className="industrialFooterValue">
    769
    </h3>
  </div>
</div>
          
{/* 
          <div className="industrialFooterCard">
            <i className="fa-solid fa-chart-pie dashboard-stat-icon"></i>

            <div>
              <span>Tỷ lệ lấp đầy TB</span>
               
              <h3>62,4%</h3>
            </div>
          </div> */}

          
                     <div className="industrialFooterCard">
  <span className="industrialFooterTitle">
   Tỷ lệ lấp đầy TB
  </span>

  <div className="industrialFooterInfo">
   <i className="fa-solid fa-chart-pie dashboard-stat-icon"></i>

    <h3 className="industrialFooterValue">
    62,4%
    </h3>
  </div>
</div>
    

        </div>

      </div>

    </div>

    {/* <!-- Table --> */}
    <div className="industrialTableCard">

      <div className="industrialCardHeader">
        <h3>Danh sách khu công nghiệp</h3>
      </div>

      <div className="table-responsive">

        <table className="industrialTable">

          <thead>
            <tr>
              <th>STT</th>
              <th>Tên khu công nghiệp</th>
              <th>Địa điểm</th>
              <th>Tổng diện tích (ha)</th>
              <th>Đất CN (ha)</th>
              <th>Tỷ lệ lấp đầy (%)</th>
              <th>Doanh nghiệp</th>
              <th>Lao động</th>
              <th>Trạng thái</th>
              <th>Thao tác</th>
            </tr>
          </thead>

          <tbody>

            <tr>
              <td>1</td>
              <td className="industrialName">KCN Vàm Cống</td>
              <td>H. Lấp Vò, Đồng Tháp giáp Long Xuyên</td>
              <td>1.480</td>
              <td>950</td>

              <td>
                <div className="industrialTableProgress">
                  <div className="industrialTableProgressBar width78"></div>
                </div>

                <span>78,5%</span>
              </td>

              <td>128</td>
              <td>45.678</td>

              <td>
                <span className="industrialStatus">
                  Đang hoạt động
                </span>
              </td>

              <td>
                <div className="industrialAction">
                  <i className="fa-regular fa-eye"></i>
                  <i className="fa-solid fa-ellipsis-vertical"></i>
                </div>
              </td>
            </tr>

            <tr>
              <td>2</td>
              <td className="industrialName">KCN Bình Hòa</td>
              <td>H. Châu Thành</td>
              <td>318</td>
              <td>221</td>

              <td>
                <div className="industrialTableProgress">
                  <div className="industrialTableProgressBar width85"></div>
                </div>

                <span>85,2%</span>
              </td>

              <td>56</td>
              <td>18.230</td>

              <td>
                <span className="industrialStatus">
                  Đang hoạt động
                </span>
              </td>

              <td>
                <div className="industrialAction">
                  <i className="fa-regular fa-eye"></i>
                  <i className="fa-solid fa-ellipsis-vertical"></i>
                </div>
              </td>
            </tr>

            <tr>
              <td>3</td>
              <td className="industrialName">KCN Bình Hòa 2</td>
              <td>H. Châu Thành</td>
              <td>250</td>
              <td>180</td>

              <td>
                <div className="industrialTableProgress">
                  <div className="industrialTableProgressBar width72"></div>
                </div>

                <span>72,1%</span>
              </td>

              <td>28</td>
              <td>9.845</td>

              <td>
                <span className="industrialStatus">
                  Đang hoạt động
                </span>
              </td>

              <td>
                <div className="industrialAction">
                  <i className="fa-regular fa-eye"></i>
                  <i className="fa-solid fa-ellipsis-vertical"></i>
                </div>
              </td>
            </tr>

            <tr>
              <td>4</td>
              <td className="industrialName">KCN Thoại Sơn</td>
              <td>H. Thoại Sơn</td>
              <td>247</td>
              <td>150</td>

              <td>
                <div className="industrialTableProgress">
                  <div className="industrialTableProgressBar width60"></div>
                </div>

                <span>60,7%</span>
              </td>

              <td>32</td>
              <td>11.250</td>

              <td>
                <span className="industrialStatus">
                  Đang hoạt động
                </span>
              </td>

              <td>
                <div className="industrialAction">
                  <i className="fa-regular fa-eye"></i>
                  <i className="fa-solid fa-ellipsis-vertical"></i>
                </div>
              </td>
            </tr>

            <tr>
              <td>5</td>
              <td className="industrialName">KCN Hội An</td>
              <td>H. Chợ Mới</td>
              <td>296</td>
              <td>190</td>

              <td>
                <div className="industrialTableProgress">
                  <div className="industrialTableProgressBar width64"></div>
                </div>

                <span>64,2%</span>
              </td>

              <td>38</td>
              <td>12.640</td>

              <td>
                <span className="industrialStatus">
                  Đang hoạt động
                </span>
              </td>

              <td>
                <div className="industrialAction">
                  <i className="fa-regular fa-eye"></i>
                  <i className="fa-solid fa-ellipsis-vertical"></i>
                </div>
              </td>
            </tr>

          </tbody>

        </table>

      </div>

      <div className="industrialPagination">

        <p>
          Hiển thị 1 - 5 trong tổng số 8 khu công nghiệp
        </p>

        <div className="industrialPaginationRight">

          <select>
            <option>10 / trang</option>
          </select>

          <div className="industrialPageNumbers">
            <button>
              <i className="fa-solid fa-chevron-left"></i>
            </button>

            <button className="activePage">1</button>
            <button>2</button>

            <button>
              <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>

        </div>

      </div>

    </div>

  </div>





















  {/* MODAL VÙNG 1 */}

 {/* {
                    openIndustrialModal && (
<div className="industrialModalOverlay">

  
  <div className="industrialModalContainer">

   
    <div className="industrialModalBreadcrumb">
      <span className="industrialModalBreadcrumbTextModal">Khu công nghiệp</span>
      <span className="industrialModalBreadcrumbArrow">&gt;</span>
      <span className="industrialModalBreadcrumbActiveModal">Thêm khu công nghiệp</span>
    </div>

   
    <div className="industrialModalTitleBox">
      <h2 className="industrialModalTitle">Thêm khu công nghiệp</h2>
    </div>

  
    <div className="industrialModalStepWrapper">

      <div className="industrialModalStepItem">
        <div className="industrialModalStepCircleActive">1</div>
        <span className="industrialModalStepTextActive">
          Thông tin chung
        </span>
      </div>

      <div className="industrialModalStepLine"></div>

      <div className="industrialModalStepItem">
        <div className="industrialModalStepCircle">2</div>
        <span className="industrialModalStepText">
          Thông tin chi tiết
        </span>
      </div>

      <div className="industrialModalStepLine"></div>

      <div className="industrialModalStepItem">
        <div className="industrialModalStepCircle">3</div>
        <span className="industrialModalStepText">
          Xác nhận
        </span>
      </div>

    </div>

   
    <div className="industrialModalFormWrapper">

      <div className="industrialModalFormHeaderModal">
        Thông tin chung
      </div>

      <div className="industrialModalFormGrid">

        
        <div className="industrialModalFormColumn">

         
          <div className="industrialModalFieldBox">
            <label className="industrialModalLabelModal">
              Tên khu công nghiệp <span>*</span>
            </label>

            <input
              type="text"
              className="industrialModalInput"
              placeholder="Nhập tên khu công nghiệp"
            />
          </div>

          <div className="industrialModalFieldBox">
            <label className="industrialModalLabelModal">
              Mã khu công nghiệp <span>*</span>
            </label>

            <input
              type="text"
              className="industrialModalInput"
              placeholder="Nhập mã khu công nghiệp (VD: KCN001)"
            />

            <span className="industrialModalNoteModal">
              Mã viết tắt, duy nhất trong hệ thống
            </span>
          </div>

       
          <div className="industrialModalFieldBox">
            <label className="industrialModalLabelModal">
              Loại hình khu công nghiệp <span>*</span>
            </label>

            <select className="industrialModalSelect">
              <option>Chọn loại hình khu công nghiệp</option>
            </select>
          </div>

          <div className="industrialModalFieldBox">
            <label className="industrialModalLabelModal">
              Tỉnh/Thành phố <span>*</span>
            </label>

            <select className="industrialModalSelect">
              <option>An Giang</option>
            </select>
          </div>

        
          <div className="industrialModalFieldBox">
            <label className="industrialModalLabelModal">
              Huyện/Thị xã/Thành phố <span>*</span>
            </label>

            <select className="industrialModalSelect">
              <option>Chọn huyện/thị xã/thành phố</option>
            </select>
          </div>

      
          <div className="industrialModalFieldBox">
            <label className="industrialModalLabelModal">
              Xã/Phường/Thị trấn <span>*</span>
            </label>

            <select className="industrialModalSelect">
              <option>Chọn xã/phường/thị trấn</option>
            </select>
          </div>

        </div>

       
        <div className="industrialModalFormColumn">

         
          <div className="industrialModalTopGrid">

            <div className="industrialModalTopGridLeft">
              <label className="industrialModalLabelModal">
                Quyết định thành lập <span>*</span>
              </label>

              <input
                type="text"
                className="industrialModalInput"
                placeholder="Nhập số quyết định"
              />
            </div>

            <div className="industrialModalTopGridRight">
              <label className="industrialModalLabelModal">
                Ngày quyết định <span>*</span>
              </label>

              <div className="industrialModalDateBox">
                <input
                  type="text"
                  className="industrialModalDateInput"
                  placeholder="dd/mm/yyyy"
                />

                <i className="fa-regular fa-calendar industrialModalDateIcon"></i>
              </div>
            </div>

          </div>

         
          <div className="industrialModalFieldBox">
            <label className="industrialModalLabelModal">
              Cơ quan ban hành <span>*</span>
            </label>

            <input
              type="text"
              className="industrialModalInput"
              placeholder="Nhập cơ quan ban hành quyết định"
            />
          </div>

        
          <div className="industrialModalFieldBox share-content">
            <label className="industrialModalLabelModal">
              Chủ đầu tư hạ tầng <span>*</span>
            </label>

            <input
              type="text"
              className="industrialModalInput"
              placeholder="Nhập tên chủ đầu tư hạ tầng"
            />
          </div>

      
          <div className="industrialModalFieldBox share-content">
            <label className="industrialModalLabelModal">
              Tình trạng hoạt động <span>*</span>
            </label>

            <select className="industrialModalSelect">
              <option>Chọn tình trạng hoạt động</option>
            </select>
          </div>

          
          <div className="industrialModalFieldBox share-content">
            <label className="industrialModalLabelModal">
              Thời gian hoạt động
            </label>

            <div className="industrialModalDateRange">

              <div className="industrialModalDateRangeItem">
                <span className="industrialModalDateText">
                  Từ ngày
                </span>

                <input
                  type="text"
                  className="industrialModalDateRangeInput"
                  placeholder="dd/mm/yyyy"
                />

                <i className="fa-regular fa-calendar industrialModalDateRangeIcon"></i>
              </div>

              <div className="industrialModalDateRangeItem">
                <span className="industrialModalDateText">
                  Đến ngày
                </span>

                <input
                  type="text"
                  className="industrialModalDateRangeInput"
                  placeholder="dd/mm/yyyy"
                />

                <i className="fa-regular fa-calendar industrialModalDateRangeIcon"></i>
              </div>

            </div>
          </div>

        </div>

      </div>

    </div>

  
    <div className="industrialModalWarningBox">

      <div className="industrialModalWarningIcon">
        i
      </div>

      <div className="industrialModalWarningContent">
        <div className="industrialModalWarningTitleModal">
          Lưu ý
        </div>

        <div className="industrialModalWarningTextModal">
          Các trường có dấu (*) là bắt buộc phải nhập.
        </div>
      </div>

    </div>

  
    <div className="industrialModalFooter">

      <button className="industrialModalCancelButton"  onClick={handleCloseIndustrialModal}>
        Hủy
      </button>

      <button className="industrialModalBackButton"  onClick={handleCloseIndustrialModal}>
        Quay lại
      </button>

      <button className="industrialModalNextButton"  onClick={handleNextStep }>
        Tiếp tục
        <i className="fa-solid fa-arrow-right industrialModalNextIcon"></i>
      </button>

    </div>

  </div>

</div>
 )
                } */}
{/* END MODAL VÙNG 1 */}







{/*  */}
















{/* MODAL VÙNG 3 MÀN HINH */}
 {/* MODAL INSIDE COL-SM-10 */}
      {/* {showCreateModal && (
        <div className="industrial-zone-modal-wrapper">

          {currentStep === 1 && (
            <div className="industrial-zone-modal-container">

              <div className="industrial-zone-modal-breadcrumb">
                <span className="industrial-zone-modal-breadcrumb-item">
                  Khu công nghiệp
                </span>

                <i className="fas fa-chevron-right industrial-zone-modal-breadcrumb-icon"></i>

                <span className="industrial-zone-modal-breadcrumb-active">
                  Thêm khu công nghiệp
                </span>
              </div>

              <h2 className="industrial-zone-modal-title">
                Thêm khu công nghiệp
              </h2>

              
              <div className="industrial-zone-step-wrapper">

                <div className="industrial-zone-step-item-active">

                  <div className="industrial-zone-step-number-active">
                    1
                  </div>

                  <span className="industrial-zone-step-label-active">
                    Thông tin chung
                  </span>

                </div>

                <div className="industrial-zone-step-line"></div>

                <div className="industrial-zone-step-item">

                  <div className="industrial-zone-step-number">
                    2
                  </div>

                  <span className="industrial-zone-step-label">
                    Thông tin chi tiết
                  </span>

                </div>

                <div className="industrial-zone-step-line"></div>

                <div className="industrial-zone-step-item">

                  <div className="industrial-zone-step-number">
                    3
                  </div>

                  <span className="industrial-zone-step-label">
                    Xác nhận
                  </span>

                </div>

              </div>

             
              <div className="industrial-zone-form-card">

                <h3 className="industrial-zone-form-title">
                  Thông tin chung
                </h3>

                <div className="industrial-zone-form-grid">

                  <div className="industrial-zone-form-group">

                    <label className="industrial-zone-form-label">
                      Tên khu công nghiệp <span>*</span>
                    </label>

                    <input
                      type="text"
                      className="industrial-zone-form-input"
                      placeholder="Nhập tên khu công nghiệp"
                    />

                  </div>

                  <div className="industrial-zone-form-group">

                    <label className="industrial-zone-form-label">
                      Quyết định thành lập <span>*</span>
                    </label>

                    <input
                      type="text"
                      className="industrial-zone-form-input"
                      placeholder="Nhập số quyết định"
                    />

                  </div>

                  <div className="industrial-zone-form-group">

                    <label className="industrial-zone-form-label">
                      Mã khu công nghiệp <span>*</span>
                    </label>

                    <input
                      type="text"
                      className="industrial-zone-form-input"
                      placeholder="Nhập mã khu công nghiệp (VD: KCN001)"
                    />

                    <span className="industrial-zone-form-note">
                      Mã viết tắt, duy nhất trong hệ thống
                    </span>

                  </div>

                  <div className="industrial-zone-form-group">

                    <label className="industrial-zone-form-label">
                      Cơ quan ban hành <span>*</span>
                    </label>

                    <input
                      type="text"
                      className="industrial-zone-form-input"
                      placeholder="Nhập cơ quan ban hành quyết định"
                    />

                  </div>

                  <div className="industrial-zone-form-group">

                    <label className="industrial-zone-form-label">
                      Loại hình khu công nghiệp <span>*</span>
                    </label>

                    <select className="industrial-zone-form-select">
                      <option>Chọn loại hình khu công nghiệp</option>
                    </select>

                  </div>

                  <div className="industrial-zone-form-group">

                    <label className="industrial-zone-form-label">
                      Chủ đầu tư hạ tầng <span>*</span>
                    </label>

                    <input
                      type="text"
                      className="industrial-zone-form-input"
                      placeholder="Nhập tên chủ đầu tư hạ tầng"
                    />

                  </div>

                  <div className="industrial-zone-form-group">

                    <label className="industrial-zone-form-label">
                      Tỉnh/Thành phố <span>*</span>
                    </label>

                    <select className="industrial-zone-form-select">
                      <option>An Giang</option>
                    </select>

                  </div>

                  <div className="industrial-zone-form-group">

                    <label className="industrial-zone-form-label">
                      Tình trạng hoạt động <span>*</span>
                    </label>

                    <select className="industrial-zone-form-select">
                      <option>Chọn tình trạng hoạt động</option>
                    </select>

                  </div>

                  <div className="industrial-zone-form-group">

                    <label className="industrial-zone-form-label">
                      Huyện/Thị xã/Thành phố <span>*</span>
                    </label>

                    <select className="industrial-zone-form-select">
                      <option>Chọn huyện/thị xã/thành phố</option>
                    </select>

                  </div>

                  <div className="industrial-zone-form-group">

                    <label className="industrial-zone-form-label">
                      Thời gian hoạt động
                    </label>

                    <div className="industrial-zone-date-group">

                      <input
                        type="text"
                        className="industrial-zone-date-input"
                        placeholder="Từ ngày"
                      />

                      <input
                        type="text"
                        className="industrial-zone-date-input"
                        placeholder="Đến ngày"
                      />

                    </div>

                  </div>

                  <div className="industrial-zone-form-group">

                    <label className="industrial-zone-form-label">
                      Xã/Phường/Thị trấn <span>*</span>
                    </label>

                    <select className="industrial-zone-form-select">
                      <option>Chọn xã/phường/thị trấn</option>
                    </select>

                  </div>

                </div>

              </div>

              <div className="industrial-zone-warning-box">

                <i className="fas fa-info-circle industrial-zone-warning-icon"></i>

                <span className="industrial-zone-warning-text">
                  Các trường có dấu (*) là bắt buộc phải nhập.
                </span>

              </div>

              <div className="industrial-zone-footer-button">

                <button
                  className="industrial-zone-cancel-button"
                
                >
                  Hủy
                </button>

                <button
                  className="industrial-zone-disabled-button"
                >
                  Quay lại
                </button>

                <button
                  className="industrial-zone-next-button"
                  
                >
                  Tiếp tục
                  <i className="fas fa-arrow-right industrial-zone-next-icon"></i>
                </button>

              </div>

            </div>
          )}

         
          {currentStep === 2 && (
            <div className="industrial-zone-modal-container">

              <div className="industrial-zone-success-alert">

                <div className="industrial-zone-success-left">

                  <div className="industrial-zone-success-icon">
                    <i className="fas fa-check"></i>
                  </div>

                  <div className="industrial-zone-success-content">

                    <h4 className="industrial-zone-success-title">
                      Đã lưu tạm thành công
                    </h4>

                    <p className="industrial-zone-success-desc">
                      Dữ liệu đã được lưu tạm lúc 15:42:30 12/05/2026
                    </p>

                  </div>

                </div>

                <button className="industrial-zone-success-close">
                  <i className="fas fa-times"></i>
                </button>

              </div>

              <h2 className="industrial-zone-modal-title">
                Thêm khu công nghiệp
              </h2>

           
              <div className="industrial-zone-step-wrapper">

                <div className="industrial-zone-step-item-done">
                  <div className="industrial-zone-step-number-done">
                    1
                  </div>

                  <span className="industrial-zone-step-label-done">
                    Thông tin chung
                  </span>
                </div>

                <div className="industrial-zone-step-line-active"></div>

                <div className="industrial-zone-step-item-active">
                  <div className="industrial-zone-step-number-active">
                    2
                  </div>

                  <span className="industrial-zone-step-label-active">
                    Thông tin chi tiết
                  </span>
                </div>

                <div className="industrial-zone-step-line"></div>

                <div className="industrial-zone-step-item">
                  <div className="industrial-zone-step-number">
                    3
                  </div>

                  <span className="industrial-zone-step-label">
                    Xác nhận
                  </span>
                </div>

              </div>

              <div className="industrial-zone-detail-grid">

                <div className="industrial-zone-detail-left">

                  <div className="industrial-zone-form-group">
                    <label className="industrial-zone-form-label">
                      Diện tích quy hoạch (ha) <span>*</span>
                    </label>

                    <input
                      type="text"
                      className="industrial-zone-form-input"
                      defaultValue="250"
                    />
                  </div>

                  <div className="industrial-zone-form-group">
                    <label className="industrial-zone-form-label">
                      Tỷ lệ lấp đầy dự kiến (%) <span>*</span>
                    </label>

                    <input
                      type="text"
                      className="industrial-zone-form-input"
                      defaultValue="70"
                    />
                  </div>

                  <div className="industrial-zone-form-group">
                    <label className="industrial-zone-form-label">
                      Thuộc khu kinh tế
                    </label>

                    <select className="industrial-zone-form-select">
                      <option>Khu kinh tế cửa khẩu Vĩnh Xương</option>
                    </select>
                  </div>

                  <div className="industrial-zone-map-box">

                    <div className="industrial-zone-map-header">
                      Ranh giới khu công nghiệp (Vẽ trên bản đồ)
                    </div>

                    <div className="industrial-zone-map-demo">

                      <div className="industrial-zone-map-polygon"></div>

                      <div className="industrial-zone-map-label">
                        250 ha
                      </div>

                    </div>

                    <button className="industrial-zone-draw-button">
                      Vẽ lại ranh giới
                    </button>

                  </div>

                </div>

                <div className="industrial-zone-detail-right">

                  <div className="industrial-zone-form-group">
                    <label className="industrial-zone-form-label">
                      Diện tích đất công nghiệp (ha)
                    </label>

                    <input
                      type="text"
                      className="industrial-zone-form-input"
                      defaultValue="180"
                    />
                  </div>

                  <div className="industrial-zone-form-group">
                    <label className="industrial-zone-form-label">
                      Tổng vốn đầu tư (tỷ đồng)
                    </label>

                    <input
                      type="text"
                      className="industrial-zone-form-input"
                      defaultValue="1.250"
                    />
                  </div>

                  <div className="industrial-zone-form-group">

                    <label className="industrial-zone-form-label">
                      Vị trí địa lý <span>*</span>
                    </label>

                    <div className="industrial-zone-radio-group">

                      <label className="industrial-zone-radio-item">

                        <input
                          type="radio"
                          name="location"
                          checked
                        />

                        Trong KKT

                      </label>

                      <label className="industrial-zone-radio-item">

                        <input
                          type="radio"
                          name="location"
                        />

                        Ngoài KKT

                      </label>

                    </div>

                  </div>

                  <div className="industrial-zone-upload-box">

                    <div className="industrial-zone-upload-title">
                      Quyết định chủ trương đầu tư
                    </div>

                    <div className="industrial-zone-upload-row">

                      <button className="industrial-zone-upload-button">
                        + Chọn tập tin
                      </button>

                      <div className="industrial-zone-file-item">

                        <i className="far fa-file-pdf industrial-zone-file-icon"></i>

                        <div className="industrial-zone-file-info">
                          <span>QD-chu-truong-dau-tu.pdf</span>
                          <small>1.2 MB</small>
                        </div>

                      </div>

                    </div>

                  </div>

                  <div className="industrial-zone-upload-box">

                    <div className="industrial-zone-upload-title">
                      Quyết định thành lập / Giấy chứng nhận đầu tư
                    </div>

                    <div className="industrial-zone-upload-row">

                      <button className="industrial-zone-upload-button">
                        + Chọn tập tin
                      </button>

                      <div className="industrial-zone-file-item">

                        <i className="far fa-file-pdf industrial-zone-file-icon"></i>

                        <div className="industrial-zone-file-info">
                          <span>QD-thanh-lap-kcn.pdf</span>
                          <small>1.5 MB</small>
                        </div>

                      </div>

                    </div>

                  </div>

                  <div className="industrial-zone-form-group">

                    <label className="industrial-zone-form-label">
                      Ghi chú
                    </label>

                    <textarea
                      className="industrial-zone-textarea"
                      placeholder="Nhập ghi chú (nếu có)"
                    ></textarea>

                  </div>

                </div>

              </div>

              <div className="industrial-zone-footer-button">

                <button
                  className="industrial-zone-back-button"
                 
                >
                  Quay lại
                </button>

                <button
                  className="industrial-zone-save-button"
                >
                  Lưu tạm
                </button>

                <button
                  className="industrial-zone-next-button"
                
                >
                  Tiếp tục
                </button>

              </div>

            </div>
          )}

        
          {currentStep === 3 && (
            <div className="industrial-zone-modal-container">

              <div className="industrial-zone-success-alert">

                <div className="industrial-zone-success-left">

                  <div className="industrial-zone-success-icon">
                    <i className="fas fa-check"></i>
                  </div>

                  <div className="industrial-zone-success-content">

                    <h4 className="industrial-zone-success-title">
                      Đã lưu tạm thành công!
                    </h4>

                    <p className="industrial-zone-success-desc">
                      Dữ liệu đã được lưu tạm lúc 15:42:30 12/05/2026
                    </p>

                  </div>

                </div>

              </div>

              <h2 className="industrial-zone-modal-title">
                Thêm khu công nghiệp
              </h2>

              
              <div className="industrial-zone-step-wrapper">

                <div className="industrial-zone-step-item-done">
                  <div className="industrial-zone-step-number-done">
                    1
                  </div>
                  <span className="industrial-zone-step-label-done">
                    Thông tin chung
                  </span>
                </div>

                <div className="industrial-zone-step-line-active"></div>

                <div className="industrial-zone-step-item-done">
                  <div className="industrial-zone-step-number-done">
                    2
                  </div>
                  <span className="industrial-zone-step-label-done">
                    Thông tin chi tiết
                  </span>
                </div>

                <div className="industrial-zone-step-line-active"></div>

                <div className="industrial-zone-step-item-active">
                  <div className="industrial-zone-step-number-active">
                    3
                  </div>
                  <span className="industrial-zone-step-label-active">
                    Xác nhận
                  </span>
                </div>

              </div>

              <div className="industrial-zone-confirm-grid">

                <div className="industrial-zone-confirm-left">

                  <div className="industrial-zone-summary-card">

                    <h3 className="industrial-zone-summary-title">
                      Thông tin chung
                    </h3>

                    <div className="industrial-zone-summary-row">
                      <span>Tên khu công nghiệp</span>
                      <strong>KCN An Phú</strong>
                    </div>

                    <div className="industrial-zone-summary-row">
                      <span>Mã khu công nghiệp</span>
                      <strong>KCNAP01</strong>
                    </div>

                    <div className="industrial-zone-summary-row">
                      <span>Quyết định thành lập</span>
                      <strong>Quyết định số 1234/QĐ-UBND</strong>
                    </div>

                    <div className="industrial-zone-summary-row">
                      <span>Ngày quyết định</span>
                      <strong>12/05/2026</strong>
                    </div>

                    <div className="industrial-zone-summary-row">
                      <span>Cơ quan ban hành</span>
                      <strong>UBND tỉnh An Giang</strong>
                    </div>

                    <div className="industrial-zone-summary-row">
                      <span>Loại hình KCN</span>
                      <strong>Khu công nghiệp</strong>
                    </div>

                    <div className="industrial-zone-summary-row">
                      <span>Chủ đầu tư hạ tầng</span>
                      <strong>Công ty CP Đầu tư An Phú</strong>
                    </div>

                  </div>

                </div>

                <div className="industrial-zone-confirm-right">

                  <div className="industrial-zone-confirm-map-box">

                    <div className="industrial-zone-confirm-map-title">
                      Ranh giới khu công nghiệp (Vẽ trên bản đồ)
                    </div>

                    <div className="industrial-zone-map-demo">
                      <div className="industrial-zone-map-polygon"></div>

                      <div className="industrial-zone-map-label">
                        250 ha
                      </div>
                    </div>

                  </div>

                </div>

              </div>

              <div className="industrial-zone-footer-button">

                <button
                  className="industrial-zone-cancel-button"
                 
                >
                  Hủy
                </button>

                <button
                  className="industrial-zone-save-button"
                >
                  Lưu tạm
                </button>

                <button
                  className="industrial-zone-complete-button"
                  
                >
                  Hoàn tất
                </button>

              </div>

            </div>
          )}

        </div>
      )} */}
{/* MODAL VÙNG 3 MÀN HINH */}

































































{/* MODAL MÀN HÌNH CHUYỂN TIẾP  */}
    {showIndustrialZoneModal && (
          <div className="industrial-zone-modal-overlay">

            <div className="industrial-zone-modal-container">

              {/* ================= STEP 1 ================= */}
              {industrialZoneStep === 1 && (
                <div className="industrial-zone-step-wrapper">

                  <div className="industrial-zone-modal-breadcrumb-modal">
                    <span>Khu công nghiệp</span>
                    <span>›</span>
                    <span>Thêm khu công nghiệp</span>
                  </div>

                  <h2 className="industrial-zone-modal-title-modal">
                    Thêm khu công nghiệp
                  </h2>

                  {/* STEP */}
                  <div className="industrial-zone-step-progress">

                    <div className="industrial-zone-step-item-active">
                      <div className="industrial-zone-step-number-active">
                        1
                      </div>

                      <span className="industrial-zone-step-label-active">
                        Thông tin chung
                      </span>
                    </div>

                    <div className="industrial-zone-step-line"></div>

                    <div className="industrial-zone-step-item">
                      <div className="industrial-zone-step-number">
                        2
                      </div>

                      <span className="industrial-zone-step-label">
                        Thông tin chi tiết
                      </span>
                    </div>

                    <div className="industrial-zone-step-line"></div>

                    <div className="industrial-zone-step-item">
                      <div className="industrial-zone-step-number">
                        3
                      </div>

                      <span className="industrial-zone-step-label">
                        Xác nhận
                      </span>
                    </div>

                  </div>

                  {/* FORM */}
                  <div className="industrial-zone-form-card">

                    <h3 className="industrial-zone-form-title-modal">
                      Thông tin chung
                    </h3>

                    <div className="industrial-zone-form-grid">

                      {/* LEFT */}
                      <div className="industrial-zone-form-column">

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Tên khu công nghiệp 
                            <span className='text-danger'>*</span>
                          </label>

                          <input
                            type="text"
                            className="industrial-zone-field-input"
                            placeholder="Nhập tên khu công nghiệp"
                          />
                        </div>

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Mã khu công nghiệp 
                             <span className='text-danger'>*</span>
                          </label>

                          <input
                            type="text"
                            className="industrial-zone-field-input"
                            placeholder="Nhập mã khu công nghiệp (VD: KCN001)"
                          />
                        </div>

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Loại hình khu công nghiệp 
                             <span className='text-danger'>*</span>
                          </label>

                          <select className="industrial-zone-field-select">
                            <option>
                              Chọn loại hình khu công nghiệp
                            </option>
                          </select>
                        </div>

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Tỉnh/Thành phố 
                             <span className='text-danger'>*</span>
                          </label>

                          <select className="industrial-zone-field-select">
                            <option>An Giang</option>
                          </select>
                        </div>

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Huyện/Thị xã/Thành phố 
                             <span className='text-danger'>*</span>
                          </label>

                          <select className="industrial-zone-field-select">
                            <option>
                              Chọn huyện/thị xã/thành phố
                            </option>
                          </select>
                        </div>

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Xã/Phường/Thị trấn 
                             <span className='text-danger'>*</span>
                          </label>

                          <select className="industrial-zone-field-select">
                            <option>
                              Chọn xã/phường/thị trấn
                            </option>
                          </select>
                        </div>

                      </div>

                      {/* RIGHT */}
                      <div className="industrial-zone-form-column">

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Quyết định thành lập 
                             <span className='text-danger'>*</span>
                          </label>

                          <input
                            type="text"
                            className="industrial-zone-field-input"
                            placeholder="Nhập số quyết định"
                          />
                        </div>

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Cơ quan ban hành 
                             <span className='text-danger'>*</span>
                          </label>

                          <input
                            type="text"
                            className="industrial-zone-field-input"
                            placeholder="Nhập cơ quan ban hành quyết định"
                          />
                        </div>

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Chủ đầu tư hạ tầng 
                             <span className='text-danger'>*</span>
                          </label>

                          <input
                            type="text"
                            className="industrial-zone-field-input"
                            placeholder="Nhập tên chủ đầu tư hạ tầng"
                          />
                        </div>

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Tình trạng hoạt động 
                             <span className='text-danger'>*</span>
                          </label>

                          <select className="industrial-zone-field-select">
                            <option>
                              Chọn tình trạng hoạt động
                            </option>
                          </select>
                        </div>

                        <div className="industrial-zone-field-row">

                          <div className="industrial-zone-field-half">
                            <label className="industrial-zone-field-label-modal">
                              Ngày quyết định 
                               <span className='text-danger'>*</span>
                            </label>

                            <input
                              type="text"
                              className="industrial-zone-field-input"
                              placeholder="dd/mm/yyyy"
                            />
                          </div>

                          <div className="industrial-zone-field-half">
                            <label className="industrial-zone-field-label-modal">
                              Thời gian hoạt động
                            </label>

                            <div className="industrial-zone-date-row">

                              <input
                                type="text"
                                className="industrial-zone-field-input"
                                placeholder="Từ ngày"
                              />

                              <input
                                type="text"
                                className="industrial-zone-field-input"
                                placeholder="Đến ngày"
                              />

                            </div>
                          </div>

                        </div>

                      </div>

                    </div>

                  </div>

                  {/* NOTE */}
                  <div className="industrial-zone-note-box">
                    <div className="industrial-zone-note-icon">
                      i
                    </div>

                    <div className="industrial-zone-note-content">
                      <span className="industrial-zone-note-title-modal">
                        Lưu ý
                      </span>

                      <p className="industrial-zone-note-text-modal">
                        Các trường có dấu (*) là bắt buộc phải nhập.
                      </p>
                    </div>
                  </div>

                  {/* FOOTER */}
                  <div className="industrial-zone-footer-action-modal-page-one">

                    <button
                      className="industrial-zone-cancel-button"
                      onClick={closeIndustrialZoneModal}
                    >
                      Hủy
                    </button>
                       <button
                      className=" back-to"
                      onClick={closeIndustrialZoneModal}
                    >
                      Quay lại
                    </button>

                    <button
                      className="industrial-zone-next-button"
                      onClick={nextIndustrialZoneStep}
                    >
                      Tiếp tục
                      <i className="fa-solid fa-arrow-right"></i>
                    </button>

                  </div>

                </div>
              )}

              {/* ================= STEP 2 ================= */}
              {industrialZoneStep === 2 && (
                <div className="industrial-zone-step-wrapper">

                  {/* SUCCESS */}
                  {/* <div className="industrial-zone-success-toast">

                    <div className="industrial-zone-success-left">

                      <div className="industrial-zone-success-icon">
                        <i className="fa-solid fa-check"></i>
                      </div>

                      <div className="industrial-zone-success-content">
                        <h4 className="industrial-zone-success-title">
                          Đã lưu tạm thành công
                        </h4>

                        <p className="industrial-zone-success-text">
                          Dữ liệu đã được lưu tạm lúc 15:42:30 12/05/2026
                        </p>
                      </div>

                    </div>

                    <button className="industrial-zone-success-close">
                      ×
                    </button>

                  </div> */}

                  <div className="industrial-zone-modal-breadcrumb-modal">
                    <span>Khu công nghiệp</span>
                    <span>›</span>
                    <span>Thêm khu công nghiệp</span>
                  </div>

                  <h2 className="industrial-zone-modal-title-modal">
                    Thêm khu công nghiệp
                  </h2>

                  {/* STEP */}
                  <div className="industrial-zone-step-progress">

                    <div className="industrial-zone-step-item-done">
                      <div className="industrial-zone-step-number-done">
                        1
                      </div>

                      <span className="industrial-zone-step-label-done">
                        Thông tin chung
                      </span>
                       <i class="fa-solid fa-check icon-check-fnish"></i>
                    </div>

                    <div className="industrial-zone-step-line-active"></div>

                    <div className="industrial-zone-step-item-active">
                      <div className="industrial-zone-step-number-active">
                        2
                      </div>

                      <span className="industrial-zone-step-label-active">
                        Thông tin chi tiết
                      </span>
                    </div>

                    <div className="industrial-zone-step-line"></div>

                    <div className="industrial-zone-step-item">
                      <div className="industrial-zone-step-number">
                        3
                      </div>

                      <span className="industrial-zone-step-label">
                        Xác nhận
                      </span>
                    </div>

                  </div>

                  {/* FORM */}
                  <div className="industrial-zone-form-card">

                    <h3 className="industrial-zone-form-title-modal">
                      Thông tin chi tiết
                    </h3>

                    <div className="industrial-zone-form-grid">

                      {/* LEFT */}
                      <div className="industrial-zone-form-column">

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Diện tích quy hoạch (ha) 
                             <span className='text-danger'>*</span>
                          </label>

                          <input
                            type="text"
                            className="industrial-zone-field-input"
                            defaultValue="250"
                          />
                        </div>

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Tỷ lệ lấp đầy dự kiến (%) 
                             <span className='text-danger'>*</span>
                          </label>

                          <input
                            type="text"
                            className="industrial-zone-field-input"
                            defaultValue="70"
                          />
                        </div>

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Thuộc Khu kinh tế
                          </label>

                          <select className="industrial-zone-field-select">
                            <option>
                              Khu kinh tế cửa khẩu Vĩnh Xương
                            </option>
                          </select>
                        </div>

                        {/* MAP */}
                        <div className="industrial-zone-map-card">

                          <label className="industrial-zone-field-label-modal">
                            Ranh giới khu công nghiệp
                            (Vẽ trên bản đồ) 
                             <span className='text-danger'>*</span>
                          </label>

                          {/* <div className="industrial-zone-map-box">

                            <img
                              src="https://maps.wikimedia.org/osm-intl/6/52/31.png"
                              alt=""
                              className="industrial-zone-map-image"
                            />

                            <div className="industrial-zone-map-polygon"></div>

                            <div className="industrial-zone-map-area">
                              250 ha
                            </div>

                          </div> */}
                           <div className="industrial-map-container">
    
    {/* <!-- zoom --> */}
    <div className="industrial-map-zoom">
      <button className="industrial-map-zoom-in">+</button>
      <button className="industrial-map-zoom-out">−</button>
         <button className="industrial-detail-map-tool-btn">
                  ⛶
                </button>
    </div>

    {/* <!-- polygon --> */}
    <div className="industrial-map-polygon">

      {/* <!-- các điểm --> */}
      <div className="industrial-map-dot industrial-map-dot-1"></div>
      <div className="industrial-map-dot industrial-map-dot-2"></div>
      <div className="industrial-map-dot industrial-map-dot-3"></div>
      <div className="industrial-map-dot industrial-map-dot-4"></div>
      <div className="industrial-map-dot industrial-map-dot-5"></div>
      <div className="industrial-map-dot industrial-map-dot-6"></div>
      <div className="industrial-map-dot industrial-map-dot-7"></div>
      <div className="industrial-map-dot industrial-map-dot-8"></div>

      {/* <!-- text --> */}
      <div className="industrial-map-area-text">
        250 ha
      </div>
    </div>

    {/* <!-- tọa độ --> */}
    <div className="industrial-map-coordinate">
       <div className='waper-map'>

        <button className="industrial-detail-map-redraw">
                  ✎ Vẽ lại ranh giới
          </button>
           <span className='coordinates'> Tọa độ: 10.3785, 105.4352
            <i className="fa-solid fa-location-dot"></i>
           </span>
       </div>
     
    </div>

  </div>

                        </div>

                      </div>

                      {/* RIGHT */}
                      <div className="industrial-zone-form-column">

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Diện tích đất công nghiệp (ha)
                          </label>

                          <input
                            type="text"
                            className="industrial-zone-field-input"
                            defaultValue="180"
                          />
                        </div>

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Tổng vốn đầu tư (tỷ đồng)
                          </label>

                          <input
                            type="text"
                            className="industrial-zone-field-input"
                            defaultValue="1,250"
                          />
                        </div>

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Vị trí địa lý 
                             <span className='text-danger'>*</span>
                          </label>

                          <div className="industrial-zone-radio-row">

                            <label className="industrial-zone-radio-item">
                              <input
                                type="radio"
                                name="zone"
                                checked
                              />
                              Trong KKT
                            </label>

                            <label className="industrial-zone-radio-item">
                              <input
                                type="radio"
                                name="zone"
                              />
                              Ngoài KKT
                            </label>

                          </div>
                        </div>

                        {/* FILE */}
                        <div className="industrial-zone-upload-group">

                          <label className="industrial-zone-field-label-modal">
                            Quyết định chủ trương đầu tư
                          </label>

                          <div className="industrial-zone-upload-box">

                            <button className="industrial-zone-upload-button">
                              + Chọn tập tin
                            </button>

                            <div className="industrial-zone-upload-file">
                              <span>QD-chu-truong-dau-tu.pdf</span>
                              <span>1.2 MB</span>
                            </div>

                          </div>

                        </div>

                        <div className="industrial-zone-upload-group">

                          <label className="industrial-zone-field-label-modal">
                            Quyết định thành lập /
                            Giấy chứng nhận đầu tư
                          </label>

                          <div className="industrial-zone-upload-box">

                            <button className="industrial-zone-upload-button">
                              + Chọn tập tin
                            </button>

                            <div className="industrial-zone-upload-file">
                              <span>QD-thanh-lap-kcn.pdf</span>
                              <span>1.5 MB</span>
                            </div>

                          </div>

                        </div>

                        <div className="industrial-zone-field-group">

                          <label className="industrial-zone-field-label-modal">
                            Ghi chú
                          </label>

                          <textarea
                            className="industrial-zone-textarea"
                            placeholder="Nhập ghi chú (nếu có)"
                          ></textarea>

                        </div>

                      </div>

                    </div>

                  </div>

                  {/* NOTE */}
                  <div className="industrial-zone-note-box">
                    <div className="industrial-zone-note-icon">
                      i
                    </div>

                    <div className="industrial-zone-note-content">
                      <span className="industrial-zone-note-title-modal">
                        Lưu ý
                      </span>

                      <p className="industrial-zone-note-text-modal">
                        Các trường có dấu (*) là bắt buộc phải nhập.
                      </p>
                    </div>
                  </div>

          

                  {/* FOOTER */}
                  <div className="industrial-zone-footer-action-modal">

                    <button
                      className="back-to "
                      onClick={prevIndustrialZoneStep}
                    >
                      Quay lại
                    </button>

                    <div className="industrial-zone-footer-right">

                      <button className="industrial-zone-save-button">
                        Lưu tạm
                      </button>

                      <button
                        className="industrial-zone-next-button"
                        onClick={nextIndustrialZoneStep}
                      >
                        Tiếp tục
                      </button>

                    </div>

                  </div>

                </div>
              )}


              {/* ================STEP 3 ============================= */}
               {industrialZoneStep === 3 && (
                <div className="industrial-zone-step-wrapper">

                  {/* SUCCESS */}
                  <div className="industrial-zone-success-toast">

                    <div className="industrial-zone-success-left">

                      <div className="industrial-zone-success-icon">
                        <i className="fa-solid fa-check"></i>
                      </div>

                      <div className="industrial-zone-success-content">
                        <h4 className="industrial-zone-success-title">
                          Đã lưu tạm thành công
                        </h4>

                        <p className="industrial-zone-success-text">
                          Dữ liệu đã được lưu tạm lúc 15:42:30 12/05/2026
                        </p>
                      </div>

                    </div>

                    <button className="industrial-zone-success-close">
                      ×
                    </button>

                  </div>

                  <div className="industrial-zone-modal-breadcrumb-modal">
                    <span>Khu công nghiệp</span>
                    <span>›</span>
                    <span>Thêm khu công nghiệp</span>
                  </div>

                  <h2 className="industrial-zone-modal-title-modal">
                    Thêm khu công nghiệp
                  </h2>

                  {/* STEP */}
                  <div className="industrial-zone-step-progress">

                    <div className="industrial-zone-step-item-done">
                      <div className="industrial-zone-step-number-done">
                      1
                      </div>

                      <span className="industrial-zone-step-label-done">
                        Thông tin chung
                      </span>
                      <i class="fa-solid fa-check icon-check-fnish"></i>
                    </div>

                    <div className="industrial-zone-step-line-active"></div>

                    <div className="industrial-zone-step-item-active">
                      <div className="industrial-zone-step-number-active">
                        2
                      </div>

                      <span className="industrial-zone-step-label-active">
                        Thông tin chi tiết
                      </span>
                    </div>

                    <div className="industrial-zone-step-line"></div>

                    <div className="industrial-zone-step-item">
                      <div className="industrial-zone-step-number">
                        3
                      </div>

                      <span className="industrial-zone-step-label">
                        Xác nhận
                      </span>
                    </div>

                  </div>

                  {/* FORM */}
                  <div className="industrial-zone-form-card">

                    <h3 className="industrial-zone-form-title-modal">
                      Thông tin chi tiết
                    </h3>

                    <div className="industrial-zone-form-grid">

                      {/* LEFT */}
                      <div className="industrial-zone-form-column">

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Diện tích quy hoạch (ha) 
                             <span className='text-danger'>*</span>
                          </label>

                          <input
                            type="text"
                            className="industrial-zone-field-input"
                            defaultValue="250"
                          />
                        </div>

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Tỷ lệ lấp đầy dự kiến (%) 
                             <span className='text-danger'>*</span>
                          </label>

                          <input
                            type="text"
                            className="industrial-zone-field-input"
                            defaultValue="70"
                          />
                        </div>

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Thuộc Khu kinh tế
                          </label>

                          <select className="industrial-zone-field-select">
                            <option>
                              Khu kinh tế cửa khẩu Vĩnh Xương
                            </option>
                          </select>
                        </div>

                        {/* MAP */}
                        <div className="industrial-zone-map-card">

                          <label className="industrial-zone-field-label-modal">
                            Ranh giới khu công nghiệp
                            (Vẽ trên bản đồ) 
                             <span className='text-danger'>*</span>
                          </label>

                          {/* <div className="industrial-zone-map-box">

                            <img
                              src="https://maps.wikimedia.org/osm-intl/6/52/31.png"
                              alt=""
                              className="industrial-zone-map-image"
                            />

                            <div className="industrial-zone-map-polygon"></div>

                            <div className="industrial-zone-map-area">
                              250 ha
                            </div>

                          </div> */}
                           <div className="industrial-map-container">
    
    {/* <!-- zoom --> */}
    <div className="industrial-map-zoom">
      <button className="industrial-map-zoom-in">+</button>
      <button className="industrial-map-zoom-out">−</button>
         <button className="industrial-detail-map-tool-btn">
                  ⛶
                </button>
    </div>

    {/* <!-- polygon --> */}
    <div className="industrial-map-polygon">

      {/* <!-- các điểm --> */}
      <div className="industrial-map-dot industrial-map-dot-1"></div>
      <div className="industrial-map-dot industrial-map-dot-2"></div>
      <div className="industrial-map-dot industrial-map-dot-3"></div>
      <div className="industrial-map-dot industrial-map-dot-4"></div>
      <div className="industrial-map-dot industrial-map-dot-5"></div>
      <div className="industrial-map-dot industrial-map-dot-6"></div>
      <div className="industrial-map-dot industrial-map-dot-7"></div>
      <div className="industrial-map-dot industrial-map-dot-8"></div>

      {/* <!-- text --> */}
      <div className="industrial-map-area-text">
        250 ha
      </div>
    </div>

    {/* <!-- tọa độ --> */}
    <div className="industrial-map-coordinate">
       <div className='waper-map'>

        <button className="industrial-detail-map-redraw">
                  ✎ Vẽ lại ranh giới
          </button>
           <span className='coordinates'> Tọa độ: 10.3785, 105.4352
            <i className="fa-solid fa-location-dot"></i>
           </span>
       </div>
     
    </div>

  </div>

                        </div>

                      </div>

                      {/* RIGHT */}
                      <div className="industrial-zone-form-column">

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Diện tích đất công nghiệp (ha)
                          </label>

                          <input
                            type="text"
                            className="industrial-zone-field-input"
                            defaultValue="180"
                          />
                        </div>

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Tổng vốn đầu tư (tỷ đồng)
                          </label>

                          <input
                            type="text"
                            className="industrial-zone-field-input"
                            defaultValue="1,250"
                          />
                        </div>

                        <div className="industrial-zone-field-group">
                          <label className="industrial-zone-field-label-modal">
                            Vị trí địa lý 
                             <span className='text-danger'>*</span>
                          </label>

                          <div className="industrial-zone-radio-row">

                            <label className="industrial-zone-radio-item">
                              <input
                                type="radio"
                                name="zone"
                                checked
                              />
                              Trong KKT
                            </label>

                            <label className="industrial-zone-radio-item">
                              <input
                                type="radio"
                                name="zone"
                              />
                              Ngoài KKT
                            </label>

                          </div>
                        </div>

                        {/* FILE */}
                        <div className="industrial-zone-upload-group">

                          <label className="industrial-zone-field-label-modal">
                            Quyết định chủ trương đầu tư
                          </label>

                          <div className="industrial-zone-upload-box">

                            <button className="industrial-zone-upload-button">
                              + Chọn tập tin
                            </button>

                            <div className="industrial-zone-upload-file">
                              <span>QD-chu-truong-dau-tu.pdf</span>
                              <span>1.2 MB</span>
                            </div>

                          </div>

                        </div>

                        <div className="industrial-zone-upload-group">

                          <label className="industrial-zone-field-label-modal">
                            Quyết định thành lập /
                            Giấy chứng nhận đầu tư
                          </label>

                          <div className="industrial-zone-upload-box">

                            <button className="industrial-zone-upload-button">
                              + Chọn tập tin
                            </button>

                            <div className="industrial-zone-upload-file">
                              <span>QD-thanh-lap-kcn.pdf</span>
                              <span>1.5 MB</span>
                            </div>

                          </div>

                        </div>

                        <div className="industrial-zone-field-group">

                          <label className="industrial-zone-field-label-modal">
                            Ghi chú
                          </label>

                          <textarea
                            className="industrial-zone-textarea"
                            placeholder="Nhập ghi chú (nếu có)"
                          ></textarea>

                        </div>

                      </div>

                    </div>

                  </div>

                  {/* NOTE */}
                  <div className="industrial-zone-note-box">
                    <div className="industrial-zone-note-icon">
                      i
                    </div>

                    <div className="industrial-zone-note-content">
                      <span className="industrial-zone-note-title-modal">
                        Lưu ý
                      </span>

                      <p className="industrial-zone-note-text-modal">
                        Các trường có dấu (*) là bắt buộc phải nhập.
                      </p>
                    </div>
                  </div>

       
                  {/* FOOTER */}
                  <div className="industrial-zone-footer-action-modal">
          <div className="industrial-detail-note-time">
          Đã lưu tạm lúc 15:42:30 12/05/2026
        </div>
                    <button
                      className="back-to "
                      onClick={prevIndustrialZoneStep}
                    >
                      Quay lại
                    </button>

                    <div className="industrial-zone-footer-right">

                      <button className="industrial-zone-save-button">
                        Lưu tạm
                      </button>

                      <button
                        className="industrial-zone-next-button"
                        onClick={nextIndustrialZoneStep}
                      >
                        Tiếp tục
                      </button>

                    </div>

                  </div>

                </div>
              )}

              {/* ================= STEP 4 ================= */}
              {industrialZoneStep === 4 && (
                <div className="industrial-zone-step-wrapper">

                  {/* SUCCESS */}
                  <div className="industrial-zone-success-toast">

                    <div className="industrial-zone-success-left">

                      <div className="industrial-zone-success-icon">
                        <i className="fa-solid fa-check"></i>
                      </div>

                      <div className="industrial-zone-success-content">
                        <h4 className="industrial-zone-success-title">
                          Đã lưu tạm thành công!
                        </h4>

                        <p className="industrial-zone-success-text">
                          Dữ liệu đã được lưu tạm lúc 15:42:30 12/05/2026
                        </p>
                      </div>

                    </div>

                    <button className="industrial-zone-success-close">
                      ×
                    </button>

                  </div>

                  <div className="industrial-zone-modal-breadcrumb-modal">
                    <span>Khu công nghiệp</span>
                    <span>›</span>
                    <span>Thêm khu công nghiệp</span>
                  </div>

                  <h2 className="industrial-zone-modal-title-modal">
                    Thêm khu công nghiệp
                  </h2>

                  {/* STEP */}
                  <div className="industrial-zone-step-progress">

                    <div className="industrial-zone-step-item-done">
                      <div className="industrial-zone-step-number-done">
                        1
                      </div>

                      <span className="industrial-zone-step-label-done">
                        Thông tin chung
                      </span>
                      <i className="fa-solid fa-check icon-check-fnish"></i>
                    </div>

                    <div className="industrial-zone-step-line-active"></div>

                    <div className="industrial-zone-step-item-done">
                      <div className="industrial-zone-step-number-done">
                       2
                      </div>

                      <span className="industrial-zone-step-label-done">
                        Thông tin chi tiết
                      </span>
                      <i className="fa-solid fa-check icon-check-fnish"></i>
                    </div>

                    <div className="industrial-zone-step-line-active"></div>

                    <div className="industrial-zone-step-item-active">
                      <div className="industrial-zone-step-number-active">
                        3
                      </div>

                      <span className="industrial-zone-step-label-active">
                        Xác nhận
                      </span>
                    </div>

                  </div>

                  {/* CONFIRM */}
                  <div className="industrial-zone-confirm-grid">

                    {/* LEFT */}
                    <div className="industrial-zone-confirm-left">

                      <div className="industrial-zone-confirm-card">

                        <h3 className="industrial-zone-confirm-title">
                          Thông tin chung
                        </h3>

                        <div className="industrial-zone-confirm-row">
                          <span>Tên khu công nghiệp</span>
                          <strong>KCN An Phú</strong>
                        </div>

                        <div className="industrial-zone-confirm-row">
                          <span>Mã khu công nghiệp</span>
                          <strong>KCNAP01</strong>
                        </div>

                        <div className="industrial-zone-confirm-row">
                          <span>Quyết định thành lập</span>
                          <strong>1234/QĐ-UBND</strong>
                        </div>

                        <div className="industrial-zone-confirm-row">
                          <span>Ngày quyết định</span>
                          <strong>12/05/2026</strong>
                        </div>

                        <div className="industrial-zone-confirm-row">
                          <span>Cơ quan ban hành</span>
                          <strong>UBND tỉnh An Giang</strong>
                        </div>

                        <div className="industrial-zone-confirm-row">
                          <span>Loại hình KCN</span>
                          <strong>Khu công nghiệp</strong>
                        </div>

                        <div className="industrial-zone-confirm-row">
                          <span>Chủ đầu tư hạ tầng</span>
                          <strong>Công ty CP Đầu tư An Phú</strong>
                        </div>

                        <div className="industrial-zone-confirm-row">
                          <span>Tỉnh/Thành phố</span>
                          <strong>An Giang</strong>
                        </div>

                        <div className="industrial-zone-confirm-row">
                          <span>Huyện/Thị xã/Thành phố</span>
                          <strong>Huyện An Phú</strong>
                        </div>

                        <div className="industrial-zone-confirm-row">
                          <span>Xã/Phường/Thị trấn</span>
                          <strong>Xã An Phú</strong>
                        </div>

                        <div className="industrial-zone-confirm-row">
                          <span>Tình trạng hoạt động</span>

                          <div className="industrial-zone-status-active">
                            Đang hoạt động
                          </div>
                        </div>

                      </div>

                      <div className="industrial-zone-confirm-card">

                        <h3 className="industrial-zone-confirm-title">
                          Thông tin chi tiết
                        </h3>

                        <div className="industrial-zone-confirm-row">
                          <span>Diện tích quy hoạch</span>
                          <strong>250 ha</strong>
                        </div>

                        <div className="industrial-zone-confirm-row">
                          <span>Diện tích đất công nghiệp</span>
                          <strong>180 ha</strong>
                        </div>

                        <div className="industrial-zone-confirm-row">
                          <span>Tỷ lệ lấp đầy dự kiến</span>
                          <strong>70 %</strong>
                        </div>

                        <div className="industrial-zone-confirm-row">
                          <span>Tổng vốn đầu tư</span>
                          <strong>1.250 tỷ đồng</strong>
                        </div>

                        <div className="industrial-zone-confirm-row">
                          <span>Thuộc Khu kinh tế</span>
                          <strong>
                            Khu kinh tế cửa khẩu Vĩnh Xương
                          </strong>
                        </div>

                        <div className="industrial-zone-confirm-row">
                          <span>Vị trí địa lý</span>
                          <strong>Trong KKT</strong>
                        </div>

                        <div className="industrial-zone-confirm-row">
                          <span>Thời gian hoạt động</span>
                          <strong>
                            Từ 12/05/2026 đến 12/05/2076 (50 năm)
                          </strong>
                        </div>

                      </div>

                    </div>

                    {/* RIGHT */}
                    <div className="industrial-zone-confirm-right">

                      <div className="industrial-zone-confirm-card">

                        <h3 className="industrial-zone-confirm-title">
                          Ranh giới khu công nghiệp
                          (Vẽ trên bản đồ)
                        </h3>

                        {/* <div className="industrial-zone-confirm-map">

                          <img
                            src="https://maps.wikimedia.org/osm-intl/6/52/31.png"
                            alt=""
                            className="industrial-zone-confirm-map-image"
                          />

                          <div className="industrial-zone-confirm-polygon"></div>

                          <div className="industrial-zone-confirm-area">
                            250 ha
                          </div>

                        </div> */}
                                    <div className="industrial-map-container">
    
    {/* <!-- zoom --> */}
    <div className="industrial-map-zoom">
      <button className="industrial-map-zoom-in">+</button>
      <button className="industrial-map-zoom-out">−</button>
         <button className="industrial-detail-map-tool-btn">
                  ⛶
                </button>
    </div>

    {/* <!-- polygon --> */}
    <div className="industrial-map-polygon">

      {/* <!-- các điểm --> */}
      <div className="industrial-map-dot industrial-map-dot-1"></div>
      <div className="industrial-map-dot industrial-map-dot-2"></div>
      <div className="industrial-map-dot industrial-map-dot-3"></div>
      <div className="industrial-map-dot industrial-map-dot-4"></div>
      <div className="industrial-map-dot industrial-map-dot-5"></div>
      <div className="industrial-map-dot industrial-map-dot-6"></div>
      <div className="industrial-map-dot industrial-map-dot-7"></div>
      <div className="industrial-map-dot industrial-map-dot-8"></div>

      {/* <!-- text --> */}
      <div className="industrial-map-area-text">
        250 ha
      </div>
    </div>

    {/* <!-- tọa độ --> */}
    <div className="industrial-map-coordinate">
       <div className='waper-map-finish'>

        {/* <button className="industrial-detail-map-redraw">
                  ✎ Vẽ lại ranh giới
          </button> */}
           <span className='coordinates-finish'> Tọa độ: 10.3785, 105.4352
            <i className="fa-solid fa-location-dot"></i>
           </span>
       </div>
     
    </div>

  </div>

                      </div>

                      <div className="industrial-zone-confirm-card">

                        <h3 className="industrial-zone-confirm-title">
                          Hồ sơ, tài liệu đính kèm
                        </h3>

                        <div className="industrial-zone-document-item-after">
                            <ul className='industrial-zone-document-item-after-list'>
                              <li className='industrial-zone-document-item-after-item'>
                                <i className="fa-regular fa-file-pdf icon-file-pdf"></i></li>
                              <li className='industrial-zone-document-item-after-item'>
                                QD-chu-truong-dau-tu.pdf
                                <br/>
                                <strong className='capacity'> 1.2 MB</strong>

                              </li>
                             
                            </ul>
                            <ul className='industrial-zone-document-item-after-list'>
                              <li lassName='industrial-zone-document-item-after-item'>
                                 <i className="fa-solid fa-download icon-download-solid"></i>
                              </li>
                            </ul>
                          
                          
                        </div>

                        <div className="industrial-zone-document-item-below">
                          <ul className='industrial-zone-document-item-after-list'>
                              <li className='industrial-zone-document-item-after-item'>
                                <i className="fa-regular fa-file-pdf icon-file-pdf"></i></li>
                              <li className='industrial-zone-document-item-after-item'>
                                QD-thanh-lap-kcn.pdf
                                <br/>
                                <strong className='capacity'> 1.5 MB</strong>

                              </li>
                             
                            </ul>
                            <ul className='industrial-zone-document-item-after-list'>
                              <li lassName='industrial-zone-document-item-after-item'>
                                 <i className="fa-solid fa-download icon-download-solid"></i>
                              </li>
                            </ul>
                          
                           
                          
                        </div>

                      </div>

                      <div className="industrial-zone-confirm-card">

                        <h3 className="industrial-zone-confirm-title">
                          Ghi chú
                        </h3>

                        <p className="industrial-zone-confirm-note">
                          KCN An Phú nằm tại cửa khẩu Vĩnh Xương,
                          thuận lợi cho phát triển công nghiệp và logistics.
                        </p>

                      </div>

                    </div>

                  </div>

                  {/* FOOTER */}
                  <div className="industrial-zone-footer-action-modal ">
                    <div className="industrial-zone-footer-right">
                          <button   className="industrial-zone-cancel-button"  onClick={prevIndustrialZoneStep}>
                                <i class="fa-solid fa-arrow-left icon-back-page"></i>
                                Quay lại
                          </button>
                    </div>

                   

                    <div className="industrial-zone-footer-right">
                       <button
                      className="industrial-zone-cancel-button"
                      onClick={closeIndustrialZoneModal}
                    >
                      Hủy
                    </button>

                      <button className="industrial-zone-save-button save-btn-temporary">
                        <i className="fa-solid fa-lock icon-lock-temporary"></i>
                        Lưu tạm
                      </button>

                      <button
                        className="industrial-zone-finish-button"
                        onClick={closeIndustrialZoneModal}
                      >
                        Hoàn tất
                        <i className="fa-solid fa-check icon-check-save"></i>
                      </button>

                    </div>

                  </div>

                </div>
              )}

            </div>

          </div>
        )}



{/* MODAL MÀN HÌNH CHUYỂN TIẾP  */}

</div>
        );
    }

export default KhuCongNghiep;